<template>
  <v-card class="chatKeyword" flat>
    <v-row class="table-header">
      <v-col>關鍵字</v-col>
      <v-col style="max-width: 300px"></v-col>
    </v-row>
    <template v-for="(keyword, i) in keywords">
      <v-row class="align-center my-2">
        <template v-if="!keyword.editing">
          <v-col>
            <div>{{ keyword.word }}</div>
          </v-col>
        </template>
        <template v-else>
          <v-col>
           <v-textarea hide-details height="100" outlined v-model="keyword.word" :rules="[$rules.notEmpty]"></v-textarea>
          </v-col>
        </template>
    
        <v-col style="max-width: 300px">
          <v-btn icon color="green" class="mx-1" v-if="keyword.editing" @click="save(keyword)">
            <v-icon>fa-save</v-icon>
          </v-btn>
          <DeleteConfirmBtn icon color="red" btnClass="mx-1" @delete="deletekeyword(keyword)">
            <v-icon>fa-trash-alt</v-icon>
          </DeleteConfirmBtn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </template>
    <v-btn block class="pink mt-6" @click="addRow">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
  </v-card> 
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
export default {
  components: { DeleteConfirmBtn },
  data() {
    return {
      keywords: []
    }
  },
  created() {
    this.getKeywords()
  },
  methods: {
    getKeywords() {
      this.axios('/admin/chat/keyword').then(response => {
        this.keywords = response.data
      })
    },
    deletekeyword(keyword) {
      if(!keyword.id) {
        this.keywords.splice(this.keywords.findIndex(e => e == keyword), 1)
      }
      else {
        this.axios.delete('/admin/chat/keyword', {data: {
          ids: [keyword.id]
        }}).then(response => {
          this.$root.$emit('alert', 'success', '刪除成功')
          this.keywords.splice(this.keywords.findIndex(e => e == keyword), 1)
        }).catch(() => {
          this.$root.$emit('alert', 'error', '刪除失敗')
        })
      }
    },
    addRow() {
      this.keywords.push({word: '', editing: true})
    },
    save(keyword) {
      this.axios.post('/admin/chat/keyword', {
        words: [keyword.word]
      }).then(response => {
        this.$root.$emit('alert', 'success', '修改成功')
        this.getKeywords()
      }).catch(() => {
        this.$root.$emit('alert', 'error', '修改失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.chatKeyword {
  padding: 40px;
}
</style>